// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer_Footer__19RDH","Footer_Divider":"footer_Footer_Divider__3JNod"};